// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__eYpxL","box":"WorkspacesBox_box__2gGZg","node":"WorkspacesBox_node__2O2o8"};